const carouselContentPic = (language: string) => {
  const content: { [key in string]: any[] } = {
    "zh-CN": [
      {
        title: "查竞对",
        pic: "22df34cb.png",
        titlePic: "6f6ded16.png",
      },
      {
        title: "找爆品",
        pic: "97e03230.png",
        titlePic: "6b50b5dc.png",
      },
      {
        title: "筛素材",
        pic: "67fa2baa.png",
        titlePic: "e27dcee8.png",
      },
      {
        title: "录直播",
        pic: "7d1e7f53.png",
        titlePic: "6dc7615b.png",
      },
      {
        title: "选达人",
        pic: "e52fad66.png",
        titlePic: "3ef7128e.png",
      },
    ],
    "th-TH": [
      {
        title: "查竞对",
        pic: "79758ddf.png",
        titlePic: "f201c169.png",
      },
      {
        title: "找爆品",
        pic: "c42a34d1.png",
        titlePic: "7e82ddfa.png",
      },
      {
        title: "筛素材",
        pic: "033ee756.png",
        titlePic: "6a26a4ea.png",
      },
      {
        title: "录直播",
        pic: "8dfb17fa.png",
        titlePic: "662d3bbd.png",
      },
      {
        title: "选达人",
        pic: "4eacac91.png",
        titlePic: "b9b77650.png",
      },
    ],
    "en-US": [
      {
        title: "查竞对",
        pic: "5776c3b3.png",
        titlePic: "747b2335.png",
      },
      {
        title: "找爆品",
        pic: "c4812eda.png",
        titlePic: "8c0f5807.png",
      },
      {
        title: "筛素材",
        pic: "872fdff5.png",
        titlePic: "fe7c6dc5.png",
      },
      {
        title: "录直播",
        pic: "62ad06ea.png",
        titlePic: "18376444.png",
      },
      {
        title: "选达人",
        pic: "41829392.png",
        titlePic: "e0503dc3.png",
      },
    ],
  };
  return content[language];
};

const adPics = [
  {
    url: "d529d0a8.png",
  },
  {
    url: "ffd1bd68.png",
  },
  {
    url: "19a99abd.png",
  },
  {
    url: "38f454b0.png",
  },
  {
    url: "d73a648a.png",
  },
  {
    url: "a9e55aa7.png",
  },
  {
    url: "e3e8f1a7.png",
  },
  {
    url: "8e5f36aa.png",
  },
  {
    url: "7ddd1f96.png",
  },
  {
    url: "a6a68cea.png",
  },
  {
    url: "6843319a.png",
  },
  {
    url: "bff34d5a.png",
  },
  {
    url: "7b093593.png",
  },
  {
    url: "695bed36.png",
  },
  {
    url: "1fe794c9.png",
  },
  {
    url: "08c4ed35.png",
  },
];

// 配置哪些ip和语言使用最新的登录样式
const isNewLoginConfig = ({ language }: { language: string }) => {
  const country = window.KALO_DATA.reqCountry;
  // 判断中国ip 香港 台湾 澳门  然后语言是中文或者英文
  if (country === "China" || country === "Hong Kong" || country === "Taiwan" || country === "Macao") {
    // if (language === "zh-CN" || language === "en-US" || language === "th-TH") {
    return true;
    // }
  }
  if (language === "zh-CN") return true;
  return false;
};

export { carouselContentPic, adPics, isNewLoginConfig };
